// stylageFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const stylageFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Stylage Fillers Dubai - Elite Body Home Dubai",
            "description": "Stylage Fillers are an advanced line of dermal fillers designed to address a variety of aesthetic concerns such as wrinkles, fine lines, and loss of facial volume.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/stylage-fillers/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Stylage Fillers Dubai - Elite Body Home Dubai",
                "description": "Stylage Fillers are an advanced line of dermal fillers designed to address a variety of aesthetic concerns such as wrinkles, fine lines, and loss of facial volume.",
                "url": "https://elitebodyhome.com/services/stylage-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T12:53:42+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-61.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-61.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Stylage Fillers",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Stylage Fillers Dubai - Elite Body Home Dubai",
                "description": "Stylage Fillers are an advanced line of dermal fillers designed to address a variety of aesthetic concerns such as wrinkles, fine lines, and loss of facial volume.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-61.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Stylage Fillers Dubai"],
        "hero": {
            "title": "Stylage Fillers Dubai",
            "subtitle": "Advanced Hyaluronic Acid Fillers",
            "description": "Restore youthfulness with Stylage Fillers - long-lasting solutions for wrinkles, volume loss, and facial contouring with natural-looking results."
        },
        "howItWorks": {
            "title": "Process of Stylage Fillers",
            "description": "Easy Filler treatment with minimal downtime and almost immediate results."
        },
        "procedureSteps": {
            "heading": "Stylage Filler Procedure",
            "para": "Here is an outline of how the process works:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Your provider will assess your skin and discuss your aesthetic goals.",
                    "icon": "fa-regular fa-comment-medical"
                },
                {
                    "title": "Numbing Cream",
                    "desc": "A topical anesthetic is applied to maximize comfort.",
                    "icon": "fa-regular fa-spray-can"
                },
                {
                    "title": "Injection Process",
                    "desc": "Precision application to lift, plump, and smooth targeted areas.",
                    "icon": "fa-regular fa-syringe"
                },
                {
                    "title": "Post-Injection Care",
                    "desc": "Gentle massage to even out filler distribution.",
                    "icon": "fa-regular fa-hand-sparkles"
                }
            ]
        },

        "benefits": {
            "heading": "Benefits of Stylage Fillers",
            "subheading": "",
            "para": "The unique properties of Stylage Fillers offer various aesthetic and skin-health benefits:",
            "items": [
                {
                    "title": "Natural-Looking Results",
                    "desc": "Hyaluronic acid mimics the body's natural moisture for perfect plumpness.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "Customizable Treatment",
                    "desc": "Multiple products available for wrinkles, volume loss, and contouring.",
                    "icon": "fa-regular fa-sliders"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Results last 9 months to over a year depending on treatment area.",
                    "icon": "fa-regular fa-hourglass"
                },
                {
                    "title": "Improved Skin Hydration",
                    "desc": "Hyaluronic acid increases skin moisture and elasticity.",
                    "icon": "fa-regular fa-droplet"
                },
                {
                    "title": "Antioxidant Protection",
                    "desc": "Mannitol protects from free radicals and reduces swelling.",
                    "icon": "fa-regular fa-shield-heart"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "Resume normal activities shortly after procedure.",
                    "icon": "fa-regular fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "Are Stylage Fillers Right For You?",
            "para": "Consider if this treatment suits your skin type, age and aesthetic goals:",
            "items": [
                {
                    "title": "Age",
                    "desc": "Most patients are over 30 when signs of aging become noticeable.",
                    "icon": "fa-regular fa-user-clock"
                },
                {
                    "title": "Skin Type",
                    "desc": "Recommended for all skin types with moderate to severe wrinkles.",
                    "icon": "fa-regular fa-face-frown-open"
                },
                {
                    "title": "Facial Contouring",
                    "desc": "Ideal for sculpting cheeks, lips or jawlines.",
                    "icon": "fa-regular fa-vector-square"
                },
                {
                    "title": "Health Status",
                    "desc": "Candidates should be in good health with no severe allergies to HA products.",
                    "icon": "fa-regular fa-heart-pulse"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Proper preparation helps achieve best results and reduces side effects:",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Stop aspirin, ibuprofen for at least a week before treatment to minimize bruising.",
                    "icon": "fa-regular fa-pills"
                },
                {
                    "title": "Limit Alcohol/Smoking",
                    "desc": "Avoid 24-48 hours prior as they can impair healing.",
                    "icon": "fa-regular fa-ban-smoking"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water for better skin response to hyaluronic acid.",
                    "icon": "fa-regular fa-glass-water"
                },
                {
                    "title": "Clean Skin",
                    "desc": "Arrive with clean skin free of makeup, lotions or skincare products.",
                    "icon": "fa-regular fa-broom"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Stylage Fillers provide long-lasting, natural-looking results:",
            "items": [
                {
                    "title": "Immediate Improvement",
                    "desc": "Visible changes in treated areas right after injection.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Results can last up to a year or longer depending on treatment area.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Low Maintenance",
                    "desc": "Fewer touch-ups needed compared to other fillers.",
                    "icon": "fa-solid fa-thumbs-up"
                },
                {
                    "title": "Natural Enhancement",
                    "desc": "Blends with your skin for fullness without the 'pumped' look.",
                    "icon": "fa-solid fa-face-grin-stars"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": ""
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long do Stylage Fillers last?",
                    "answer": "Stylage Fillers typically last between 9 to 12 months, but in some cases, results may last up to 18 months, depending on the specific filler and treated area."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Mild swelling, redness, and bruising are the most common side effects. These usually resolve within a few days. Thanks to the antioxidant mannitol, post-procedural inflammation is minimized."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Results are visible immediately after the treatment, though minor swelling may temporarily obscure the final outcome. Once swelling subsides (within 1-3 days), the full effects can be appreciated."
                },
                {
                    "question": "Can Stylage Fillers be combined with other treatments?",
                    "answer": "Yes, Stylage Fillers can be combined with other cosmetic treatments such as Botox, microneedling, or chemical peels for more comprehensive facial rejuvenation."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Stylage-Fillers-in-Dubai-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/123.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Dermal-Filler-2.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/rtuytjyt-3.jpg"
            ]
        },
        "product": {
            "id": 114,
            "title": "Stylage Dermal Fillers",
            "price": 799,
            "description": "Stylage is a premium hyaluronic acid-based dermal filler infused with antioxidants to smooth wrinkles, restore volume, and improve skin elasticity. Ideal for lips, cheeks, and nasolabial folds."
        },
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "فيلر ستايلج في دبي - عيادة إيليت بودي هوم دبي",
            "description": "فيلر ستايلج هو خط متقدم من الفيلر الجلدي المصمم لمعالجة مجموعة متنوعة من المشاكل الجمالية مثل التجاعيد والخطوط الدقيقة وفقدان حجم الوجه.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/stylage-fillers/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "فيلر ستايلج في دبي - عيادة إيليت بودي هوم دبي",
                "description": "فيلر ستايلج هو خط متقدم من الفيلر الجلدي المصمم لمعالجة مجموعة متنوعة من المشاكل الجمالية مثل التجاعيد والخطوط الدقيقة وفقدان حجم الوجه.",
                "url": "https://elitebodyhome.com/services/stylage-fillers/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T12:53:42+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-61.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-61.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "فيلر ستايلج",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "فيلر ستايلج في دبي - عيادة إيليت بودي هوم دبي",
                "description": "فيلر ستايلج هو خط متقدم من الفيلر الجلدي المصمم لمعالجة مجموعة متنوعة من المشاكل الجمالية مثل التجاعيد والخطوط الدقيقة وفقدان حجم الوجه.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-61.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر ستايلج في دبي"],
        "hero": {
            "title": "فيلر ستايلج في دبي",
            "subtitle": "فيلر حمض الهيالورونيك المتقدم",
            "description": "استعيدي شبابك مع فيلر ستايلج - حلول طويلة الأمد للتجاعيد وفقدان الحجم ونحت الوجه مع نتائج طبيعية المظهر."
        },
        "howItWorks": {
            "title": "عملية فيلر ستايلج",
            "description": "علاج سهل مع وقت تعافي قصير ونتائج شبه فورية."
        },
        "procedureSteps": {
            "heading": "إجراء فيلر ستايلج",
            "para": "إليك نظرة عامة على كيفية العملية:",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "سيقوم المزود بتقييم بشرتك ومناقشة أهدافك الجمالية.",
                    "icon": "fa-regular fa-comment-medical"
                },
                {
                    "title": "كريم التخدير",
                    "desc": "يتم تطبيق مخدر موضعي لزيادة الراحة.",
                    "icon": "fa-regular fa-spray-can"
                },
                {
                    "title": "عملية الحقن",
                    "desc": "تطبيق دقيق لرفع وملء وتنعيم المناطق المستهدفة.",
                    "icon": "fa-regular fa-syringe"
                },
                {
                    "title": "العناية بعد الحقن",
                    "desc": "تدليك لطيف لتوزيع الفيلر بشكل متساوٍ.",
                    "icon": "fa-regular fa-hand-sparkles"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد فيلر ستايلج",
            "subheading": "",
            "para": "تقدم الخصائص الفريدة لفيلر ستايلج العديد من الفوائد الجمالية والصحية للبشرة:",
            "items": [
                {
                    "title": "نتائج طبيعية المظهر",
                    "desc": "يحاكي حمض الهيالورونيك الرطوبة الطبيعية للجسم لامتلاء مثالي.",
                    "icon": "fa-regular fa-face-smile"
                },
                {
                    "title": "علاج قابل للتخصيص",
                    "desc": "تتوفر منتجات متعددة للتجاعيد وفقدان الحجم ونحت الوجه.",
                    "icon": "fa-regular fa-sliders"
                },
                {
                    "title": "آثار طويلة الأمد",
                    "desc": "تدوم النتائج من 9 أشهر إلى أكثر من سنة حسب منطقة العلاج.",
                    "icon": "fa-regular fa-hourglass"
                },
                {
                    "title": "تحسين ترطيب البشرة",
                    "desc": "يزيد حمض الهيالورونيك من رطوبة البشرة ومرونتها.",
                    "icon": "fa-regular fa-droplet"
                },
                {
                    "title": "حماية مضادة للأكسدة",
                    "desc": "يحمي المانيتول من الجذور الحرة ويقلل التورم.",
                    "icon": "fa-regular fa-shield-heart"
                },
                {
                    "title": "وقت تعافي قصير",
                    "desc": "استئناف الأنشطة الطبيعية بعد وقت قصير من الإجراء.",
                    "icon": "fa-regular fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "هل فيلر ستايلج مناسب لك؟",
            "para": "فكر فيما إذا كان هذا العلاج مناسبًا لنوع بشرتك وعمرك وأهدافك الجمالية:",
            "items": [
                {
                    "title": "العمر",
                    "desc": "معظم المرضى فوق 30 سنة عندما تصبح علامات الشيخوخة ملحوظة.",
                    "icon": "fa-regular fa-user-clock"
                },
                {
                    "title": "نوع البشرة",
                    "desc": "موصى به لجميع أنواع البشرة مع تجاعيد متوسطة إلى شديدة.",
                    "icon": "fa-regular fa-face-frown-open"
                },
                {
                    "title": "نحت الوجه",
                    "desc": "مثالي لتشكيل الخدين أو الشفاه أو خط الفك.",
                    "icon": "fa-regular fa-vector-square"
                },
                {
                    "title": "الحالة الصحية",
                    "desc": "يجب أن يكون المرشحون بصحة جيدة دون حساسية شديدة لمنتجات حمض الهيالورونيك.",
                    "icon": "fa-regular fa-heart-pulse"
                }
            ]
        },
        "preparationTips": {
            "heading": "التحضير",
            "subheading": "",
            "para": "يساعد التحضير المناسب في تحقيق أفضل النتائج ويقلل من الآثار الجانبية:",
            "items": [
                {
                    "title": "تجنب مميعات الدم",
                    "desc": "توقف عن الأسبرين والإيبوبروفين لمدة أسبوع على الأقل قبل العلاج لتقليل الكدمات.",
                    "icon": "fa-regular fa-pills"
                },
                {
                    "title": "الحد من الكحول/التدخين",
                    "desc": "تجنبها لمدة 24-48 ساعة قبل العلاج لأنها قد تعيق الشفاء.",
                    "icon": "fa-regular fa-ban-smoking"
                },
                {
                    "title": "حافظ على ترطيب جسمك",
                    "desc": "اشرب الكثير من الماء لتحسين استجابة البشرة لحمض الهيالورونيك.",
                    "icon": "fa-regular fa-glass-water"
                },
                {
                    "title": "بشرة نظيفة",
                    "desc": "احضر ببشرة نظيفة خالية من المكياج أو المستحضرات أو منتجات العناية بالبشرة.",
                    "icon": "fa-regular fa-broom"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يوفر فيلر ستايلج نتائج طويلة الأمد وطبيعية المظهر:",
            "items": [
                {
                    "title": "تحسن فوري",
                    "desc": "تغيرات مرئية في المناطق المعالجة مباشرة بعد الحقن.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "آثار طويلة الأمد",
                    "desc": "يمكن أن تدوم النتائج حتى عام أو أكثر حسب منطقة العلاج.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "صيانة قليلة",
                    "desc": "حاجة أقل للجلسات الإضافية مقارنةً بالفيلر الأخرى.",
                    "icon": "fa-solid fa-thumbs-up"
                },
                {
                    "title": "تحسين طبيعي",
                    "desc": "يمزج مع بشرتك ليمنحها امتلاء دون مظهر 'منتفخ'.",
                    "icon": "fa-solid fa-face-grin-stars"
                }
            ]
        },
        "aftercareTips": {
            "heading": "العناية بعد العلاج",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": ""
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تدوم نتائج فيلر ستايلج؟",
                    "answer": "عادةً ما تدوم نتائج فيلر ستايلج بين 9 إلى 12 شهرًا، ولكن في بعض الحالات قد تدوم النتائج حتى 18 شهرًا، حسب نوع الفيلر المحدد ومنطقة العلاج."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "التورم والاحمرار والكدمات الخفيفة هي الآثار الجانبية الأكثر شيوعًا. عادة ما تختفي هذه الآثار في غضون أيام قليلة. بفضل مضاد الأكسدة مانيتول، يتم تقليل الالتهاب بعد الإجراء."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "تكون النتائج مرئية مباشرة بعد العلاج، على الرغم من أن التورم البسيط قد يحجب النتيجة النهائية مؤقتًا. بمجرد أن يهدأ التورم (خلال 1-3 أيام)، يمكن ملاحظة التأثيرات الكاملة."
                },
                {
                    "question": "هل يمكن الجمع بين فيلر ستايلج والعلاجات الأخرى؟",
                    "answer": "نعم، يمكن الجمع بين فيلر ستايلج والعلاجات التجميلية الأخرى مثل البوتوكس أو الميكرونيدلينغ أو التقشير الكيميائي لتجديد شباب الوجه بشكل شامل."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []

    }
};
